// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Grid, makeStyles, Typography} from '@material-ui/core';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {colors} from '../../../../assets/styles/colors';
import FilterButton from '../Sections/FilterButton/FilterButton';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {GetApp} from '@material-ui/icons';
import SearchBar from '../../../../elements/SearchBar/SearchBar';
import RowItem from '../Sections/RowItem/RowItemSales';

const useStyles = makeStyles(theme => ({
  customModal: {
    '& .MuiPaper-root': {
      padding: '16px!important',
    },
  },
  root: {
    width: 520,
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: 18,
    textAlign: 'center',
  },
  divider: {
    backgroundColor: '#E8E8ED',
    margin: theme.spacing(2, 0),
  },
  groupFilter: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapFilter: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  wrapItems: {
    margin: theme.spacing(2, 0),
  },
}));

type Props = {
  open: boolean,
  setOpen: (v: boolean) => void,
};

export default function ColaboratorsSalesModal(props: Props) {
  const {open, setOpen} = props;
  const classes = useStyles();

  return (
    <CustomModal
      open={open}
      handleCloseModal={() => setOpen(false)}
      className={classes.customModal}
    >
      <div className={classes.root}>
        <Typography className={classes.title}>
          Ventas por colaborador
        </Typography>
        <Divider className={classes.divider} />
        <div className={classes.wrapFilter}>
          <div className={classes.groupFilter}>
            <FilterButton
              id="aa"
              text="Vendedores"
              selected={true}
              handleOnClick={() => {
                console.log('raa');
              }}
            />
          </div>
          <CustomButton
            startIcon={<GetApp />}
            className={classes.btnDownload}
            variant="contained"
          >
            Descargar
          </CustomButton>
        </div>
        <SearchBar
          mobile={true}
          placeholder="Buscar Vendedor"
          color="light"
          externalHandleSearch={() => {}}
        />
        <div className={classes.wrapItems}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <RowItem id={1} text="hola como estas" price="49" />
            </Grid>
            <Grid item xs={12}>
              <RowItem id={2} text="hola como estas" price="49" />
            </Grid>
          </Grid>
        </div>
      </div>
    </CustomModal>
  );
}

ColaboratorsSalesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};
